import React from 'react'
import styles from '../../css/about/us.module.css'
import imagUs from '../../assest/about/9889a6af2e15b9cd7fa0cf51f36c75993e41f7fa (2).png'
function Us() {
  return (
      <>
          <div className={styles.container}>
              <div className={styles.us}>
                  <h1>لماذا خطوة المستثمر</h1>
                  <p>
                      عندما نضع أمامك كل الخيارات المتاحة للمقارنة فإنك حتماَ ستختار
                        <br/>
                      خطوة المستثمر لتميز خدمتنا وإبداعنا المتواصل. عندما تختارنا فإنك
                        <br/>
                      تختار الجودة والخبرة التي اختارتها أبرز الشركات في المملكة 
                  </p>
              </div>
              <div>
                  <img loading='lazy' src={imagUs} alt="about us" loading='lazy'/>
              </div>
          </div>
      </>
  )
}

export default Us
//about us خطوت المستثمر